
<template>
  <div>
    <div class="csu_dialog_mask" v-if="show" @touchmove.prevent></div>
    <div :class="['dialog', 'csu_dialog', !isMobile ? 'dialog-pc' : '']" v-if="show" @touchmove.prevent>
      <div class="dialog_wrap">
        <div class="dialog_title" v-if="title">{{title}}</div>
        <i class="csu_dialog_icon_cancel" v-if="showClose" data-role="button" @click="close">
          <svg class="_svg_icon_cancel" viewBox="0 0 32 32">
            <path
              d="M17.807 16.326l4.72 4.721c0.232 0.24 0.375 0.567 0.375 0.928 0 0.739-0.599 1.337-1.337 1.337-0.362 0-0.69-0.144-0.931-0.377l0 0-4.713-4.721-4.72 4.721c-0.24 0.233-0.569 0.377-0.931 0.377-0.739 0-1.337-0.599-1.337-1.337 0-0.361 0.143-0.688 0.375-0.929l-0 0 4.72-4.721-4.72-4.721c-0.232-0.24-0.375-0.568-0.375-0.928 0-0.739 0.599-1.337 1.337-1.337 0.362 0 0.69 0.144 0.931 0.377l4.72 4.721 4.713-4.721c0.24-0.233 0.569-0.377 0.931-0.377 0.739 0 1.337 0.599 1.337 1.337 0 0.361-0.143 0.688-0.375 0.929l0-0z"
            />
          </svg>
        </i>
        <div class="dialog_con">
          <p class="txt" :style="{ textAlign: align }" v-html="msg"></p>
        </div>
        <div class="csu_btn_wrap cf">
          <a
            href="javascript:;"
            class="csu_btn csu_btn_half"
            v-if="type=='confirm' || 'alert'"
            @click="cancelClick"
          >{{cancelText}}</a>
          <a
            href="javascript:;"
            class="csu_btn csu_btn_em"
            :class="{csu_btn_half:type=='confirm'}"
            @click="confirmClick"
          >{{confirmText}}</a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
function extend(to, from) {
  Object.keys(from).forEach((key) => {
    // eslint-disable-next-line no-param-reassign
    to[key] = from[key];
  });
}

const alert = {
  type: 'alert', // alert 只有确定按钮 confirm 确定和取消按钮
  show: false,
  showClose: false,
  msg: '温馨提示',
  confirm: null,
  cancel: null,
  confirmText: '确定',
  cancelText: '取消',
  title: '',
  align: '',
  isMobile: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent),
};

export default {
  data() {
    return alert;
  },
  methods: {
    close() {
      alert.show = false;
    },
    confirmClick() {
      alert.show = false;
      alert.confirm && alert.confirm();
    },
    cancelClick() {
      alert.show = false;
      alert.cancel && alert.cancel();
    },
  },
  install(Vue) {
    /**
     * alert
     * @param options
     */
    const alertFunc = function (options) {
      if (typeof options === 'string') {
        // eslint-disable-next-line no-param-reassign
        options = {
          msg: options,
        };
      }
      const { title = '', msg = '', confirm = null, cancel = null, confirmText = '好的', align = '', showClose = false } = options;
      extend(alert, {
        showClose,
        title,
        msg,
        confirm,
        cancel,
        confirmText,
        cancelText: '取消',
        type: 'alert',
        show: true,
        align,
      });
    };
    Vue.prototype.$alert = alertFunc;

    /**
     * confirm
     * @param title
     * @param msg
     * @param confirm
     * @param cancel
     * @param csu_btnConfirmText
     * @param csu_btnCancelText
     */
    const confirmFunc = function (options) {
      const {
        title = '',
        msg = 'confirm需要至少传入msg',
        confirm = null,
        cancel = null,
        confirmText = '确定',
        cancelText = '取消',
        align = '',
        showClose = false,
      } = options;
      extend(alert, {
        showClose,
        title,
        msg,
        confirm,
        cancel,
        confirmText,
        cancelText,
        type: 'confirm',
        show: true,
        align,
      });
    };
    Vue.prototype.$confirm = confirmFunc;

    return {
      alert: alertFunc,
      confirm: confirmFunc,
    };
  },
};
</script>
<style lang="scss" scoped>
@import '@tencent/ceiba-base-components/index.scss';

.csu_dialog_mask {
  position: fixed;
  z-index: 9998;
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  background: rgba(0, 0, 0, 0.6);
}

.dialog {
  position: fixed;
  z-index: 9999;
  left: 50%;
  top: 45%;
  transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}

.csu_dialog {
  width: 80%;
  max-width: 340px;
  box-sizing: border-box;
  box-sizing: border-box;
}

.csu_dialog .dialog_wrap {
  padding-top: 24px;
  background: #fff;
  box-shadow: 0 0 3px rgba(0, 0, 0, 0.3);
  border-radius: 6px;
}

.csu_dialog .dialog_title {
  font-size: 18px;
  color: $text-color;
  font-weight: 500;
  line-height: normal;
  margin-bottom: 6px;
  text-align: center;
  word-break: break-all;
}

.csu_dialog .csu_dialog_icon_cancel {
  position: absolute;
  width: 40px;
  height: 40px;
  right: 6px;
  top: 7px;

  ._svg_icon_cancel {
    position: absolute;
    width: 28px;
    height: 28px;
    fill: #848494;
    top: 50%;
    left: 50%;
    transform: translate3d(-50%, -50%, 0);
    transform: translate3d(-50%, -50%, 0);
  }
}

.csu_dialog .dialog_con {
  padding: 0 20px;
  margin-bottom: 25px;
  border-radius: 12px;
}

.csu_dialog .dialog_con .txt {
  font-size: 16px;
  color: $text-color;
  line-height: normal;
  text-align: center;
  word-break: break-all;
}

.csu_dialog .dialog_con .txt .num {
  padding: 0 3px;
  color: $theme-color;
}

.csu_dialog .csu_btn_wrap {
  position: relative;
  overflow: hidden;
}

.csu_dialog .csu_btn_wrap .csu_btn {
  color: $text-color;
  position: relative;
  display: block;
  height: 5fpx;
  line-height: 50px;
  font-size: 16px;
  text-align: center;
  text-decoration: none;
}

.csu_dialog .csu_btn_wrap .csu_btn:after {
  content: '';
  position: absolute;
  width: 100%;
  top: 0;
  left: 0;
  right: 0;
  border-top: 1px solid $border-color;
  transform: scaleY(0.5);
  transform: scaleY(0.5);
  transform-origin: 0 0;
  transform-origin: 0 0;
}

.csu_dialog .csu_btn_wrap .csu_btn_half {
  float: left;
  width: 50%;
  position: relative;
  box-sizing: content-box;
  box-sizing: content-box;
  font-weight: 600;
  color: #8e8e93;
}

.csu_dialog .csu_btn_wrap .csu_btn_em {
  color: $theme-color;
  font-weight: 600;
}

.csu_dialog .csu_btn_wrap .csu_btn_half:before {
  content: '';
  position: absolute;
  height: 100%;
  top: 0;
  bottom: 0;
  right: 0;
  border-right: 1px solid $border-color;
  transform: scaleX(0.5);
  transform: scaleX(0.5);
  transform-origin: 0 0;
  transform-origin: 0 0;
}

.csu_dialog .csu_btn_wrap .csu_btn_em.csu_btn_half:before {
  border-right: 0;
}

// dialog-pc
.dialog-pc {
  width: 500px;
  max-width: 500px;
  box-sizing: border-box;
  box-sizing: border-box;
}

.dialog-pc .dialog_wrap {
  padding-top: 40px;
  background: #fff;
  box-shadow: 0 0 3px rgba(0, 0, 0, 0.3);
  border-radius: 24px;
}

.dialog-pc .dialog_title {
  font-size: 32px;
  height: 48px;
  padding: 0px 10px;
  font-family: PingFang SC;
  font-size: 20px;
  font-weight: 600;
  line-height: 48px;
  letter-spacing: 0px;
  text-align: center;
  color: #242424;
  margin-bottom: 20px;
}

.dialog-pc .dialog_con {
  padding: 0 40px;
  margin-bottom: 25px;
  border-radius: 12px;
}

.dialog-pc .dialog_con .txt {
  font-size: 16px;
  color: $text-color;
  line-height: normal;
  text-align: center;
  word-break: break-all;
  font-family: PingFang SC;
  font-size: 16px;
  font-weight: 400;
  line-height: 32px;
  letter-spacing: 0px;
  text-align: center;
}

.dialog-pc .csu_btn_wrap .csu_btn {
  color: #8e8e93;
  position: relative;
  display: block;
  height: 5fpx;
  line-height: 80px;
  font-size: 16px;
  text-align: center;
  text-decoration: none;
  font-weight: 500;
}

.dialog-pc .csu_btn_wrap .csu_btn_em {
  color: #1d3f7c;
  font-weight: 500;
}

</style>
